/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Company_PressInputs */

const de_commons_footer_company_press = /** @type {(inputs: Commons_Footer_Company_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presse`)
};

/** @type {(inputs: Commons_Footer_Company_PressInputs) => LocalizedString} */
const en_commons_footer_company_press = de_commons_footer_company_press;

/**

* @param {Commons_Footer_Company_PressInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_company_press = /** @type {((inputs?: Commons_Footer_Company_PressInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Company_PressInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_company_press(inputs)
	return en_commons_footer_company_press(inputs)
});